import API from '../utils/request'

// 获取车辆详细信息
export function getCarInfo(carNumber) {
    return API({
        url: `/system/monitor/getOnlineCarInfo/${carNumber}`,
        headers: {
            'Content-Type': "application/json;charset=utf-8"
        }
    })
}

//获取租车人信息
export function getCarInfo1(carNumber) {
    return API({
        url: `/system/hire/getInfoByCarNumber2/${carNumber}`,
        headers: {
            'Content-Type': "application/json;charset=utf-8"
        }
    })
}

// 获取当日车辆统计
export function getCarNum() {
    return API({
        url: `/system/monitor/countCarRegistrationInfo`,
        headers: {
            'Content-Type': "application/json;charset=utf-8"
        }
    })
}


// 获取在线车辆位置
export function getOnlineCars() {
    return API({
        url: `/system/monitor/getAllOnlineCar`,
        headers: {
            'Content-Type': "application/json;charset=utf-8"
        }
    })
}

// 远程控制
export function setPowerOff(data) {
    return API({
        url: `/system/monitor/changeStatus`,
        data: data,
        method: "post",
        headers: {
            'Content-Type': "application/json;charset=utf-8"
        }
    })
}

// 查询指定范围内车辆
export function getVehicleDistribution(date) {
    return API({
        url: `/system/monitor/getVehicleDistribution?startDate=${date?.startDate}&endDate=${date?.endDate}`,
        headers: {
            'Content-Type': "application/json;charset=utf-8"
        }
    })
}

// 高德猎鹰轨迹服务——创建圆形围栏
// 文档：https://tsapi.amap.com/v1/track/geofence/add/circle  POST
// 参数：key(高德Web服务Key)、sid(猎鹰服务编号)、name(围栏名称，同一sid下不可重复)、
//       desc(围栏描述，可选)、center(围栏中心点坐标，格式X,Y即"经度,纬度")、radius(半径，单位米，取值[1,50000])
// 返回：errcode(0代表成功)、errmsg、data.gfido(围栏唯一标识)
export function createFalconCircleFence(data) {
    // 猎鹰接口要求表单格式提交，用 URLSearchParams 序列化
    const params = new URLSearchParams();
    Object.keys(data).forEach(k => params.append(k, data[k]));
    return API({
        url: 'https://tsapi.amap.com/v1/track/geofence/add/circle',
        method: "post",
        data: params,
        headers: {
            'Content-Type': "application/x-www-form-urlencoded"
        }
    })
}

// 高德猎鹰轨迹服务——查询围栏列表
// 用于校验围栏是否已创建（避免重复创建同名围栏）
export function getFalconFenceList(params) {
    return API({
        url: 'https://tsapi.amap.com/v1/track/geofence/list',
        method: "get",
        data: params
    })
}
